import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useApi from "../../Hooks/useApi";
import showToast from "../../Helpers/toast";
import TextField from "../../Components/UI/Inputs/TextField.js";
import Button from "../../Components/UI/Buttons/Button.js";
import { SVG_USER } from "../../Assets/SVG/svg_util.js";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { request } = useApi();

  const [formData, setFormData] = useState({});
  const [error, setError] = useState("");

  const handleInputChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEmailSubmit = async () => {
    try {
      if (
        formData.email &&
        formData.email
          ?.trim()
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
      ) {
        const response = await request("POST", "/v1/auth/forgot-password", {
          data: { email: formData.email },
        });
        if (response) {
          showToast({ message: response.message });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
      } else if (formData.email) {
        setError("Please enter valid email");
      } else {
        setError("Please enter email");
      }
    } catch (error) {
      console.log(error);
      
      showToast({ message:error?.response?.data?.message ||"Error Occurred.", type: "error" });
    }
  };

  const { t } = useTranslation();

  return (
    <div className=" px-2  w-full h-full  py-20">
      <div className="border-2 border-[#E0F5FD] rounded lg:w-[500px] shadow-md mx-auto  ">
        <div className="mb-8 text-center">
          <h2 className="text-xl text-[#7DDBFF] mt-5">{t("login.loginto")}</h2>
          <h2 className="text-2xl font-bold text-[#7DDBFF]">
            {t("login.title")}
          </h2>
        </div>

        <div className="flex flex-col !px-[8%]  h-full mb-[8%]">
          <TextField
            required
            placeholder={t("login.email")}
            name="email"
            onValueChange={handleInputChange}
            value={formData.email}
            icon={<SVG_USER />}
          />
          <div className="text-red-500 text-sm mt-1  px-2 text-start">
            {error}
          </div>
          <Button
            type="full"
            label={"Submit"}
            textColor="white"
            backgroundColor="#7DDBFF"
            handler={handleEmailSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
